<template>
	<v-card>
		<v-toolbar color="grey" dark flat> 
			<v-btn icon v-on:click="cerrar" > <i class="fa fa-times"></i></v-btn>
			<v-spacer></v-spacer>
			<v-card-title> Cambiar Contraseña {{user.nombre}}</v-card-title>
		</v-toolbar>
    <v-card-text >
			<v-form ref="form" lazy-validation>
				<v-text-field v-model="newPass" label="Contraseña" ></v-text-field>
			</v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="red" v-on:click="cerrar" >
        Cancelar
      </v-btn>
      <v-btn color="primary" v-on:click="guardarUser" >
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
	import Schema from '../../core/Schema';
	import Helper from '../../core/Helper';
  export default {
    components:{},
    props: {
			user: {
				type: Object,
				default() { return {
					id:null,
					username:null,
					password:null,
					nombre:null,
					a_paterno:null,
					a_materno:null,
					activo:null,
					rol:null,
				};}
			},
		},
    data () { return {
			newPass:null,
		};},
		mounted() {},
    methods: {
			guardarUser() {
				if(!this.newPass) {
					return;
				}
				this.user.password = Helper.hash(this.newPass);
				Schema.models.User.guardar(this.user,'all', job => {
					this.$emit('getuser',job.newData);
				});
			},
			cerrar() {
				this.$emit('getuser',null);
			},
		},
		computed: {},
		watch: {}
  }
</script>
<style>
</style>
